<template>
	<div class="home">
		<header>
            <Header />
        </header>
		<main>
            <!-- notice list -->
			<section class="notice-list">
				<div class="container" style="background-color:#fff;">
					<div class="row">
						<div class="col-12">
                            <div class="notice-wrapper-title">通知公告</div>
                        </div>
					</div>
					<div class="row">
						<div class="col-12 notice-cards" v-for="(item,index) in noticeData" :key="index" @click="handleClick(item)">
							<div class="cards-notice-item">
								<div class="notice-text">
									<div class="notice-label">
										<span v-if="item.noticeCate=='入驻企业'" class="color1">入驻企业</span>
										<span v-if="item.noticeCate=='成交信息'" class="color2">成交信息</span>
										<span v-if="item.noticeCate=='系统通知'" class="color3">系统通知</span>
									</div>
									<div class="notice-date">{{item.insertTime}}</div>
								</div>
								<div class="notice-title">{{ item.noticeTitle }}</div>
								<div class="notice-desc">{{ item.noticeContent }}</div>
							</div>
                        </div>
                        <div v-if="noticeData.length == 0">
                            <el-empty description="暂无数据"></el-empty>
                        </div>
					</div>
					<div class="row ">
                        <div class="pagination  mt-2">
                            <el-pagination
                                background
                                @current-change="handleCurrentChange"
                                :current-page="query.pageIndex"
                                :page-size="query.pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="query.total">
                            </el-pagination>
                        </div>
                    </div>
				</div>
			</section>
		</main>
		<!-- <footer><Footer /></footer> -->
	</div>
</template>

<script>
import Header from '../../components/header.vue';
// import Footer from '../../components/footer.vue';
import {
    noticeList,
} from '@/api/index'
export default {
  	name: 'Home',
	components: {
		Header,
		// Footer
	},
	data() {
		return {
            noticeData:[],
            query:{
                pageIndex:1,
                pageSize:10,
                total:0,
            }
		};
		
		
	},
	mounted() {
        this.getNoticeList();
	},
    methods:{
        //获取公告列表
		async getNoticeList(){
			let param = {
				pageNum:this.query.pageIndex,
				pageSize:this.query.pageSize,
			}
			const data = await noticeList(param);
			this.noticeData = data.data.records;
		},
        handleCurrentChange(val) {
            this.query.pageIndex = val;
            this.getNoticeList();
        },
        handleClick(item){
           	sessionStorage.setItem('noticeId',item.id);
            this.$router.push({path:'/noticeDetail'})
        },
    }
}
</script>
<style lang="scss" scoped>
header {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 0.2rem 0.6rem 0 #0000001a;
    position: sticky;
    top: 0;
    z-index: 99;
}
.notice-list{
    width: 100%;
    height:auto;
    padding:20px 0 20px;
    // background-color: #fff;
    cursor:default;
	.notice-wrapper-title{
		box-sizing:border-box;
        padding:20px 10px;
        font-size:20px;
        font-weight:600;
        letter-spacing: 2px;
	}
	.notice-cards{
		width:100%;
		height:100%;
		margin-bottom:15px;
		box-sizing:border-box;
		padding:20px 20px;
		border-radius: 10px;
		font-size:0.8rem;
		box-shadow: 0 1px 2px 0 rgba(0,0,0,.05);
		.cards-notice-item{
			
			.notice-text{
				display: flex;
				margin-bottom: 10px;
				.notice-label span{
					display:inline-block;
					margin-right:10px;
					width:80px;
					height:30px;
					text-align:center;
					line-height:30px;
					font-size:13px;
					font-weight:normal;
					font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
						
				}
				.notice-date{
					color:#666;
					font-size:0.8rem;
					line-height:30px;
					margin-right: 10px;
				}
			}
			.notice-title{
				color:#333;
				font-size:1rem;
				font-weight:600;
				display: -webkit-box;
				-webkit-line-clamp: 1; 
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.notice-title:hover{
				color:#0066ff;
				cursor:pointer;
			}
			.notice-desc{
				color:#4b5563;
				margin-top:10px;
				font-size:0.8rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
			}
		}
	}
}
</style>

<style  scoped>

.color1{
	border-radius:20px;
	color:#0066ff;
	background-color: #dbeafe;
}
.color2{
	border-radius:20px;
	color:#ca8a04;
	background-color: #fef9c3;
}
.color3{
	border-radius:20px;
	color:#16a34a;
	background-color: #dcfce7;
}
</style>